let footerLoading = false;

function loadFooter(callback) {
    if ($('footer#footer').length || footerLoading) {
        callback();
        return;
    }

    footerLoading = true;
 //   sessionStorage.removeItem('loadedFooter'); // Pro vývoj, odstraní načítanou patičku z sessionStorage, aby se načítala znovu
    if (sessionStorage.loadedFooter) {
        $('.overall-wrapper').append('<footer id="footer">' + sessionStorage.loadedFooter + '</footer>');
        footerLoading = false;
        callback();
    } else {
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: '/',
            success: function (e) {
                var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find('footer#footer').html();
                if (t) {
                    $('.overall-wrapper').append('<footer id="footer">' + t + '</footer>');
                    sessionStorage.loadedFooter = t;
                }
                footerLoading = false;
                callback();
            }
        });
    }
}


$('.siteCookies__links').append($('.siteCookies__buttonWrap button'));

